<template>
  <div class="new-dispatch-modal">
    <div class="form-grid">
      <!-- From Date -->
      <div class="form-group">
        <label for="fromDate">From Date <span class="required">*</span></label>
        <input type="date" v-model="formData.fromDate" id="fromDate" required>
        <span v-if="errors.fromDate" class="error-message">Please select a From Date</span>
      </div>

      <!-- Plant Dropdown -->
      <div class="form-group">
        <label for="helper">Plant</label>
        <select v-model="formData.helper" id="helper">
          <option value="">All Plant</option>
          <option v-for="helper in helpers" :key="helper.id" :value="helper.id">
            {{ helper.name }}
          </option>
        </select>
      </div>

      <div class="form-group search-button mt-2">
        <button @click="performSearch" class="btn button-default mt-3">Search</button>
              </div>

      <div class="form-group search-button mt-2">
         <button @click="viewFullScreenReport" class="btn button-default mt-3">View</button>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div v-if="loading" class="loading-spinner">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </div>

    <!-- API Response Table -->
    <div v-if="results.length" class="results-table-wrapper">
      <div class="results-table mt-3"> 
        <table>
          <thead>
            <tr>
              <th>Business Name</th>
              <th>PO No</th>
              <th>Loading Time</th>
              <th>Unloading Time</th>
              <th>Plant</th>
              <th>Unload Location</th>
              <th>Bridging</th>
              <th>Vehicle Type</th>
              <th>Remarks</th>
              <th v-for="itemName in uniqueItemNames" :key="itemName" class="item-column">
                {{ itemName }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="9" class="text-right"><strong>Total Quantity</strong></td>
              <td v-for="sum in itemSums" :key="sum.item_id" class="item-column">
             <b>{{ sum.total_qty }}</b>   
              </td>
            </tr>
            <tr v-for="result in results" :key="result.id">
              <td>{{ result.business_name }}</td>
              <td>{{ result.refrence_no }}</td>
              <td>{{ result.loading_date_time }}</td>
              <td>{{ result.unload_date_time }}</td>
              <td>{{ result.gas_plant_name }}</td>
              <td>{{ result.unload_location }}</td>
              <td>{{ result.bridging }}</td>
              <td>{{ result.vtype }}</td>
              <td>{{ result.remarks }}</td>
              <td v-for="itemName in uniqueItemNames" :key="itemName" class="item-column">
                {{ getItemQuantity(result.items, itemName) }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            
          </tfoot>
        </table>
      </div>

      <!-- View Button -->
      <!--<div class="form-group search-button mt-2" v-if="showViewButton">
        <button @click="viewFullScreenReport" class="btn button-default mt-1">View</button>
      </div>-->
    </div>

    <!-- No Results Found -->
    <div v-if="!loading && !results.length && searched" class="no-results">
      No results found for the selected criteria.
    </div>
  </div>
</template>


<script>
import { fetchPlantOrderRequest, PurchaseOrderScheduleSummary } from '@/services/dataService';

export default {
  name: 'NewDispatch',
  data() {
    const today = new Date().toISOString().substr(0, 10);
    return {
      formData: {
        fromDate: today,
        helper: ''
      },
      helpers: [],
      results: [],
      uniqueItemNames: [],
      itemSums: [], // Item summary data
      searched: false,
      errors: {
        fromDate: false
      },
      loading: false,
      token: localStorage.getItem('token_set') || '',
      showViewButton: true // Controls the visibility of the "View" button
    };
  },

  methods: {
    async fetchPlant() {
      this.loading = true;
      try {
        const response = await fetchPlantOrderRequest(this.token);
        if (response.data.status === 'success') {
          this.helpers = response.data.data;
        } else {
          this.errors.helpers = response.data.message;
        }
      } catch (error) {
        this.errors.helpers = 'Failed to fetch plants.';
      } finally {
        this.loading = false;
      }
    },

    async performSearch() {
      this.loading = true;
      this.errors.fromDate = !this.formData.fromDate;

      if (this.errors.fromDate) {
        this.loading = false;
        return;
      }

      const params = {
        loading_date: this.formData.fromDate,
        gas_plant_id: this.formData.helper || null
      };

      try {
        const response = await PurchaseOrderScheduleSummary(params, this.token);
        if (response.data.status === 'success') {
          this.results = response.data.data.purchase_orders || [];
          this.itemSums = response.data.data.item_sums || [];
          this.extractUniqueItemNames();
        } else {
          this.results = [];
          this.uniqueItemNames = [];
        }
      } catch (error) {
        this.results = [];
        this.uniqueItemNames = [];
      } finally {
        this.searched = true;
        this.loading = false;
      }
    },

    extractUniqueItemNames() {
      const itemNamesSet = new Set();
      this.results.forEach(result => {
        result.items.forEach(item => {
          itemNamesSet.add(item.item_name);
        });
      });
      this.uniqueItemNames = Array.from(itemNamesSet);
    },

    getItemQuantity(items, itemName) {
      const item = items.find(item => item.item_name === itemName);
      return item ? item.qty : 0;
    },

    getTotalQuantity(itemName) {
      return this.results.reduce((total, result) => {
        const item = result.items.find(item => item.item_name === itemName);
        return total + (item ? item.qty : 0);
      }, 0);
    },

    viewFullScreenReport() {
  // Hide the "View" button
  this.showViewButton = false;

  // Get the table HTML content
  const tableHTML = document.querySelector('.results-table-wrapper').innerHTML;

  // URL of the company logo
  const companyLogoURL = 'img/sfa_logo.215a054b.svg'; // Replace with the actual logo URL

  const now = new Date();
  const formattedDate = now.toLocaleDateString();
  const formattedTime = now.toLocaleTimeString();

  // Open a new window
  const newWindow = window.open('', '_blank', 'width=1200,height=800');

  // Write the HTML content to the new window
  newWindow.document.write(`
    <html>
      <head>
        <title>Order Request Schedule Summary</title>
        <style>
          body { 
            margin: 0; 
            padding: 20px; 
            font-family: Arial, sans-serif; 
            background-color: #f5f5f5; 
          }
          .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
          }
          .logo {
            max-height: 100px;
          }
          h1 {
            margin: 0;
            color: #333;
          }
          .date-time {
            margin-top: 10px;
            font-size: 14px;
            color: #555;
          }
          table { 
            width: 100%; 
            border-collapse: collapse; 
            margin-bottom: 20px;
          }
          th, td { 
            border: 1px solid #ddd; 
            padding: 8px; 
            text-align: left; 
          }
          th { 
            background-color: #4CAF50; 
            color: white; 
          }
          tfoot td { 
            font-weight: bold; 
          }
        </style>
      </head>
      <body>
        <div class="header">
          <img src="${companyLogoURL}" alt="Company Logo" class="logo">
          <div class="date-time">Generated on: ${formattedDate} at ${formattedTime}</div>
          <h1>Order Request Schedule Summary</h1>
        </div>
        ${tableHTML}
      </body>
    </html>
  `);

  // Close the document stream
  newWindow.document.close();

  // Set up an event listener to re-enable the button when the new window is closed
  const interval = setInterval(() => {
    if (newWindow.closed) {
      clearInterval(interval);
      this.showViewButton = true; // Re-enable the "View" button
    }
  }, 500);
}
  },

  mounted() {
    this.fetchPlant();
  }
};
</script>


<style scoped>
.new-dispatch-modal {
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

label {
  font-weight: bold;
  margin-bottom: 8px;
}

.required {
  color: red;
}

select,
input[type="date"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
}

.results-table-wrapper {
  overflow-x: auto;
  margin-top: 20px;
}

.results-table {
  border-collapse: collapse;
  width: 100%;
}

.results-table table,
.results-table th,
.results-table td {
  border: 1px solid #ddd;
  text-align: left;
  padding: 8px;
}

.results-table th {
  background-color: #f2f2f2;
  color: #333;
}

.results-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.results-table .item-column {
  background-color: #e9f7ef;
}

.nested-table {
  width: 100%;
  border-collapse: collapse;
}

.nested-table th,
.nested-table td {
  border: 1px solid #ccc;
  padding: 5px;
  font-size: 14px;
}

.nested-table th {
  background-color: #e9ecef;
  text-align: left;
}

.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  color: #007bff;
}

.no-results {
  margin-top: 20px;
  color: red;
  font-size: 16px;
  text-align: center;
}
</style>
